
import { DetailPageProductSkuOption } from '@rcm/cart-core/src';
import { ProductImage } from '@rcm/cart-core/src/types/ProductImage';
import React, { useCallback } from 'react';

interface Props {
    image: ProductImage;
    isSelected: boolean;
    onHover: (image: ProductImage) => void;
}

export const ThumbImage = ({ image, isSelected, onHover }: Props) => {
    const handleHover = useCallback(() => { onHover(image) }, [image]);
    return <img src={image.thumbSrc} className={'ProductDetailPageTopBlock-side-thumb' + (isSelected ? ' ProductDetailPageTopBlock-side-thumb-selected' : '')}
        onMouseOver={handleHover}
        onClick={handleHover}
    />
};